import { getZonedDate } from '@eika-infrastruktur/date';
import { isNotEmptyOrNull } from '@eika-infrastruktur/format';

import { CrossBorderPaymentState } from '../../components/transaction/CrossBorderPayment/form/state';
import type { CrossBorderPaymentReceiver, CrossBorderPaymentRequest } from '../../generated-types';
import nullableZonedDateToUtc from './nullableZonedDateToUtc';

const createReceiverRequest = (state: CrossBorderPaymentState): CrossBorderPaymentReceiver => {
    const bank = state.bankValidation?.routingBicBank || state.bankValidation?.bank;
    const bankCode = state.receiver?.nationalId || bank?.nationalId;
    return {
        account: { number: state.receiver?.accountNumber ?? '', type: state.receiver?.accountType ?? 'BBAN' },
        address: state.receiver?.address,
        address2: isNotEmptyOrNull(state.receiver?.address2) ? state.receiver?.address2 : undefined,
        postcode: state.receiver?.postcode,
        town: state.receiver?.town,
        countryCode: state.receiver?.receiverCountryCode || state.country?.countryCode,
        name: state.receiver?.name ?? state.receiverName ?? '',
        bank: {
            bic: bank?.bic,
            countryCode: bank?.countryCode ?? { value: '' },
            nationalId: !state.country?.nationalIdRequirements?.required && !!bank?.bic ? undefined : bankCode,
            name: bank?.name,
        },
    };
};

const createCrossBorderPaymentRequest = (state: CrossBorderPaymentState): CrossBorderPaymentRequest => {
    const date = state.paymentDate || getZonedDate();
    const receiverRequest = createReceiverRequest(state);
    return {
        amount: state.amount ?? 0,
        currency: state.currency ?? state.country?.currency ?? 'EUR',
        fromAccount: state.fromAccount ?? { value: '' },
        authorityReport: { code: state.regulatoryCode ?? '', message: state.paymentDescription ?? '' },
        paymentDate: nullableZonedDateToUtc(date)!,
        receiver: receiverRequest,
        text: state.messageReceiver ?? '',
        priority: state.priority,
        chargeBearer: state.chargeBearer,
        transferCurrency: state.transferCurrency,
        deviceId: window.ReactNativeProps?.deviceId,
    };
};

export default createCrossBorderPaymentRequest;
